import {planTypes} from "../types/planTypes";

const initState = {
    plans: null,
    plansIsLoading: true,
};


const planReducer = (state = initState, action) => {
    switch (action.type) {
        case planTypes.GET_PLANS:
            state = {
                ...state,
                plans: action.payload,
                plansIsLoading: false,
            };
            break;
        default:
        // do nothing
    }
    return state;
};


export default planReducer;